import React from "react";
import ReactDOM from "react-dom/client";
import "./index.scss";
import AppData from "./components/AppData/AppData";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(<AppData />);
